//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/SelectFace.js";
import "../Assemblies/Assemblies.SelectComponent.js";
import "../no/ugmath.js";
import "../no/SelectObject.js";
let d=[[[0,"ChuckType",1,0],[0,"ComponentMatrix",1,0],[1,"Face",0,"SelectFace",0],[1,"Fixture",0,"Assemblies.SelectComponent",0],[0,"MateCsys",1,"NXObject",0],[1,"Parent",0,"Assemblies.SelectComponent",0],[0,"ReferPart",1,0],[0,"ReferenceCenter",1,0],[0,"Rename",1,0],[0,"StandardData",1,0],[0,"StandardPart",1,0]],[[["templatePartName"],"SetTemplatePartName",{},1,0],[["templateDataName"],"SetTemplateDataName",{},1,0],[["templateData","libraryName","catalogName","classificationName","titleName"],"InstallComponentPart",{R_:{component:"NXObject"}},5,0]],[]];
SPLM.Tooling.ElectrodeComponentBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.ElectrodeComponentBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.ElectrodeComponentBuilder.Chuck = Object.freeze({
    "Unknown" : "Unknown", "Holder" : "Holder", "Pallet" : "Pallet"});

export default SPLM;